/**
 * uiChromeStore — coordination for the app's floating chrome (2026-07-07).
 *
 * The taco FAB and the thread-return chip are app-level floats. Mid-flow
 * screens that own the bottom edge (the criteria wizard's sticky Continue
 * footer) suppress them so the bottom of the screen never stacks three
 * competing controls. Suppress on mount, release on unmount.
 */
import { create } from 'zustand';

interface UiChromeState {
  floatsSuppressed: boolean;
  suppressFloats: () => void;
  releaseFloats: () => void;
}

export const useUiChromeStore = create<UiChromeState>((set) => ({
  floatsSuppressed: false,
  suppressFloats: () => set({ floatsSuppressed: true }),
  releaseFloats: () => set({ floatsSuppressed: false }),
}));
